module.exports = __webpack_public_path__ + "img/user_img.b056b091.png";